import { Col, Row } from "react-bootstrap";

export const InfoRow = ({
  label,
  value,
}: {
  label: string;
  value?: string;
}) => {
  return (
    <Row className="mb-2">
      <Col className="col-4" style={{ fontWeight: 500 }}>
        {label + ":"}
      </Col>
      <Col className="text-right">{value}</Col>
    </Row>
  );
};
